module.exports = __webpack_public_path__ + "img/1 (88).f3be4965.png";